import React from 'react';
import img from '../../../assets/images/dhlOutros.png';
import '../../seguranca/politicas/politicas.css';
import linha from '../../../assets/linha.png';

export default function LogisticaDHL() {
  return (
    <article className="art-s mb-5 p-text">
      <section className="row m-0 sectionInit">
        <div className="c-init">
          <div className="c-init__text col-6  d-flex flex-column sect mt-5">
            <p className="fw-bolder text-decoration-underline">
              LOGÍSTICA INTERNACIONAL E CORREIO EXPRESSO - DHL
            </p>
            <p>
              A Ourominas (OM) trabalha como uma agente autorizada oficial da
              maior empresa de logística do mundo, a DHL.
            </p>
            <p>
              Fundada em 1969, a DHL é uma marca do Deutsche Post DHL Group,
              englobando três divisões: DHL Express, DHL Global Forwardin, DHL
              Freight e DHL Supply Chain. Além de ser a empresa número um do
              mundo na indústria das remessas rápidas internacionais e de
              logística, a DHL é reconhecida internacionalmente por seus
              serviços logísticos de entrega expressa em mais de 220 países.
              Esta empresa possui uma quantidade imensurável de entregas
              expressas por todos os países. E não é diferente no Brasil, onde
              milhares de entregas são feitas todos os dias.
            </p>
            <p>
              A DHL é a marca líder mundial no setor de logística, oferece um
              portfólio incomparável de serviços de logística que abrangem
              envios de encomendas nacionais e internacionais, envios e
              atendimento de e-commerce, entregas expressas internacionais,
              serviços de transporte rodoviário, aéreo e marítimo e gestão da
              cadeia de suprimentos industrial. Com cerca de 360 mil
              funcionários em mais de 220 países e territórios em todo o mundo,
              a DHL conecta pessoas e empresas de forma segura e confiável,
              possibilitando fluxos comerciais em todo o globo. Com soluções
              especializadas para mercados e indústrias em crescimento,
              incluindo os setores de tecnologia, ciências de vida e saúde,
              energia, automobilístico e varejo, além de um compromisso sólido
              com a responsabilidade corporativa e de uma presença inigualável
              nos mercados em desenvolvimento, a DHL encontra-se decisivamente
              posicionada como "a empresa de logística para o mundo".
            </p>
            <div className="div-line">
              <img src={linha} alt="linha de separação"></img>
            </div>
          </div>
          <div className="col-6 c-init__images">
            <img src={img} className="images" alt="grupo-om"></img>
          </div>
        </div>{' '}
        <section className="mt-4 sect">
          <p className=" mt-5 my-3  fw-bolder">PERGUNTAS FREQUENTES</p>
          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              O QUE SIGNIFICA A PALAVRA DHL?
            </summary>
            <p className="my-4">
              A DHL Express (acrônimo que originalmente remetia a Dalsey,
              Hillblom and Lynn) é uma divisão da Deutsche Post do setor de
              logística internacional e correio expresso. Tem sede na cidade
              alemã de Bona.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">O QUE É ENVIO POR DHL?</summary>
            <p className="mt-4">
              Ao enviar com a DHL Express, você conta com especialistas em
              transporte internacional e entregas expressas. Dispõe de uma ampla
              variedade de serviços expressos para seus documentos e encomendas,
              além de soluções de preparo e acompanhamento de seus envios, de
              acordo com sua necessidade.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">O QUE É FRETE COURIER?</summary>
            <p className="mt-4">
              Característica de entrega Courier: é a forma como também são
              conhecidos fretes expressos não entregues pelos Correios. Entre as
              empresas de courier existem a DHL, Fedex, TNT, UPS, Shopfans
              Brasil Express entre outras.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              QUAL TAMANHO MÁXIMO QUE POSSO ENVIAR?
            </summary>
            <p className="mt-4">
              Devido as dimensões das portas abertas nos nossos veículos e
              aviões, solicitamos-lhe que os seus envios não excedam os 120 cm
              em dimensão.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">QUEM PODE UTILIZAR A DHL?</summary>
            <p className="mt-4">
              Os serviços da DHL estão disponíveis tanto para Pessoas Físicas
              quanto para Pessoas Jurídicas. O que muda são os documentos
              necessários em cada um dos casos.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              POSSO UTILIZAR A DHL PARA ENVIAR DOCUMENTOS E ENCOMENDAS DENTRO DO
              BRASIL?
            </summary>
            <p className="mt-4">
              Sim, você pode utilizar a DHL para enviar documentos e encomendas
              em qualquer um dos mais de 220 países, inclusive dentro do Brasil.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              QUAL A DIFERENÇA ENTRE ENVIAR DOCUMENTOS E ENCOMENDAS?
            </summary>
            <p className="mt-4">
              Para o envio de encomendas é necessário apresentar a nota fiscal
              do produto que está sendo enviado e em alguns casos documentação
              alfandegária adicional, já para o envio de documentos você só
              precisará preencher a Nota de Entrega da DHL.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              O QUE É CONSIDERADO DOCUMENTO PARA A DHL?
            </summary>
            <p className="mt-4">
              A DHL considera como documento (sem necessitar de envio de nota
              fiscal) bilhetes de avião, cartões de visita, escrituras, desenhos
              técnicos e arquitetônicos, impressos em geral, fotografias, listas
              de preços, manuscritos, músicas (impressas ou manuscritas),
              resultados de exames médicos, passaportes, pedidos de visto e
              relatórios de modo geral.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              É PRECISO DECLARAR O CONTEÚDO DE UMA ENCOMENDA PARA ENVIAR PELA
              DHL?
            </summary>
            <p className="mt-4">
              Sim. É necessário declarar o conteúdo da embalagem para fins
              legais. No caso de pessoas físicas a declaração se dá pela
              “Declaração substitutiva de Nota Fiscal”. No caso de pessoas
              jurídicas é preciso encaminhar a nota fiscal e invoice.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              QUAL É O PRAZO MÉDIO DE ENTREGA DE ENCOMENDAS ENVIADAS PELA DHL?
            </summary>
            <p className="mt-4">
              Estados Unidos 2 dias, Europa 3 dias, consulte-nos e informaremos
              a data exata.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              QUAL O TAMANHA MÁXIMO DE UM PACOTE QUE POSSO ENVIAR?
            </summary>
            <p className="mt-4">
              Devido ao tamanho das portas abertas de furgões e aviões, pedimos
              que a remessa não exceda 120 cm em dimensão. Se for necessário
              dimensões maiores, por favor, entre em contato para que possamos
              verificar a melhor forma de envio. Para garantir a segurança do
              processo também é recomendado que o peso não exceda 50kg por
              volume.
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              COMO DEVO EMBALAR MINHA ENCOMENDA?
            </summary>
            <p className="mt-4">
              A DHL recomenda a utilização de caixas de papelão ondulado de alta
              qualidade, com reforços duplos ou triplos, em tamanho adequado
              para o conteúdo que está sendo enviado (caixas muito cheias correm
              risco de estourar). Considere também as seguintes recomendações:
            </p>
            <ul>
              <li>
                Evite a reutilização de caixas (pois elas podem perder a
                rigidez);{' '}
              </li>
              <li>
                Coloque o conteúdo no centro da caixa, deixando em torno de 6cm
                entre o objeto e as paredes da caixa;
              </li>
              <li>
                Não deixe espaços vazios, preencha com plástico bolha, divisores
                de papelão ou isopor;
              </li>
              <li>
                Lacre todas as aberturas com fita de polipropileno (fita
                plástica marrom), fita adesiva de vinil (fita isolante) ou fita
                de papel reforçado com fibra;
              </li>
              <li>
                Coloque a etiqueta na parte superior da caixa, para garantir que
                ela permaneça na vertical durante o transporte.
              </li>
            </ul>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              HÁ RESTRIÇÕES AO ENVIO DE ENCOMENDAS?
            </summary>
            <p className="mt-4">
              Sim. A DHL segue a legislação vigente no país de origem e de
              destino, o que significa que alguns itens possuem restrições
              (impossibilidade de envio ou exigência de documentos adicionais)
              para o envio de determinados itens. Veja uma lista resumida de
              itens que requerem documentação adicional para envios
              internacionais:
            </p>
            <ul>
              <li>
                Plantas e Produtos de origem vegetal (incluindo sementes,
                amostra de grãos e perecíveis);
              </li>
              <li>
                Animais e Produtos de origem animal (incluindo peles de
                animais);
              </li>
              <li>Medicamentos (com ou sem prescrição médica);</li>
              <li>Bebidas alcoólicas;</li>
              <li>Alimentos;</li>
              <li>
                Equipamento militar (incluindo armas de fogo, suas partes ou
                munição);
              </li>
              <li>Equipamentos e suprimentos médicos/odontológicos;</li>
              <li>Livros;</li>
              <li>Joias e roupas;</li>
              <li>Pertences pessoais;</li>
              <li>Tabaco;</li>
              <li>Produtos químicos;</li>
              <li>Programas de computador;</li>
              <li>Antiguidades e obras de arte;</li>
              <li>Dinheiro, cartões e cheques;</li>
              <li>Narcóticos (drogas ilegais);</li>
              <li>Produtos piratas ou falsificados;</li>
              <li>Objetos de jogatina;</li>
              <li>Material de pornografia;</li>
              <li>
                Materiais combustíveis ou perigosos (consulte informações sobre
                produtos com bateria de lítio);
              </li>
              <li>Bens usados ou recondicionados;</li>
              <li>Partes humanas (incluindo cinzas).</li>
            </ul>
          </details>
        </section>
      </section>
    </article>
  );
}
